import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSelector } from "reselect";
import { parseDate } from "../util/date.js";
export function timeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "TIME/CURRENT_DATE_TIME_UPDATED":
      return _objectSpread(_objectSpread({}, state), {}, {
        currentDateTime: action.payload.currentDateTime
      });
    default:
      return state;
  }
}
var currentDateTime = function currentDateTime(state) {
  var _state$time;
  var currentDateTime = state === null || state === void 0 || (_state$time = state.time) === null || _state$time === void 0 ? void 0 : _state$time.currentDateTime;
  return currentDateTime;
};
export var getCurrentDateTime = createSelector([currentDateTime], function (currentDateTime) {
  return parseDate(currentDateTime);
});